import { Component, Mixins, Prop } from "vue-property-decorator";
import UlBarChart from "@/models/analysis/ul-bar-chart";
import AnalysisBase, { ChartElement } from "@/models/analysis/analysis-base";
import { AnalysisGraphData } from "@/api/analysis/common/response";
import RankStampGet from "@/store/analysis/rank-stamp/get";
import * as RankStampUserCSV from "@/api/analysis/rank-stamp-user-csv";
import { isSuccess } from "@/api/response";
import Flash, { ErrorAlert } from "@/store/common/flash";
import { RankStampInputOptions } from "@/models/analysis/rank-stamp";
import { RankStampUserCSVGetRequest } from "@/api/analysis/rank-stamp-user-csv/request";

@Component({
  components: {
    UlBarChart: UlBarChart
  }
})
export default class AnalysisRankStampChart extends Mixins(AnalysisBase) {
  @Prop() data!: AnalysisGraphData;
  @Prop() inputOptions!: RankStampInputOptions;
  @Prop() index!: number;

  get rankStampChartData() {
    return this.getBarChartData(this.data);
  }

  get rankStampChartOption() {
    return this.getBarChartOptions(this.data, false, false, this.onClickChart);
  }

  /**
   * createdライフサイクルフック
   */
  async created() {}

  /**
   * beforeDestroyライフサイクルフック
   */
  async beforeDestroy() {}

  async onClickChart(
    event: MouseEvent | undefined,
    activeElements: Array<{}> | undefined
  ) {
    if (
      !event ||
      !activeElements ||
      (activeElements && activeElements.length <= 0)
    ) {
      return;
    }
    if (event.ctrlKey || event.shiftKey) {
      const element = activeElements[0] as ChartElement;
      await this.fetchRankStampUserCSV(element._index);
    }
  }

  async fetchRankStampUserCSV(elementIndex: number) {
    const rankStampUserCSVGetRequest: RankStampUserCSVGetRequest = {
      searchShopId: this.inputOptions.selectShop
        ? Number(this.inputOptions.selectShop.id)
        : null,
      date: this.inputOptions.date,
      rank: Number(
        RankStampGet.getGraphData[this.index].data.labelsData[elementIndex]
      ),
      stampCardsId: RankStampGet.getGraphData[this.index].stampCardsId
    };

    const rankStampUserCSVGetResponse = await RankStampUserCSV.get(
      rankStampUserCSVGetRequest
    );
    if (
      rankStampUserCSVGetResponse && 
      rankStampUserCSVGetResponse.statusCd !== 200
      ) {
        await Flash.setErrorNow({
          message: rankStampUserCSVGetResponse.message,
          showReloadButton: false
        } as ErrorAlert);
        return false;
    }
    
    this.saveCSV(
      rankStampUserCSVGetResponse.results.csvString,
      rankStampUserCSVGetResponse.results.fileName
    );
  }
}
